
import * as React from "react";
import { connect } from "react-redux";
import { DigitaleLedenpasLidnummerNaam } from "../presentational/DigitaleLedenpasLidnummerNaam";

const mapStateToProps = (state : any) => {
  return {
    name: state.user.name,
    email: state.user.email,
    lidnummer: state.user.lidnummer,
    isLoggedIn: state.user.isLoggedIn,
    accessToken: state.user.accessToken,
    membershipCardActivatedDate: state.user.membershipCardActivatedDate,
    birthDate: state.user.birthDate,
    userId: state.user.userId
  };
};

export const DigitaleLedenpasLidnummerNaamContainer = connect(mapStateToProps)(DigitaleLedenpasLidnummerNaam);